"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityLoader = void 0;
const pino_1 = __importDefault(require("pino"));
const walletHelper_1 = require("../../../components/pages/wallet/walletHelper");
const appConstants_1 = require("../../../constants/appConstants");
const approvalQuery_1 = require("../../../queries/approvals/approvalQuery");
const companyQuery_1 = require("../../../queries/companyQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const userSelectors_1 = require("../../../selectors/userSelectors");
const logger = (0, pino_1.default)();
let teams = [];
const activityLoader = async ({ queryClient }) => {
    const teamIdQuery = (0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID');
    let companyFeatures;
    try {
        companyFeatures = await queryClient.ensureQueryData(companyQuery_1.companyFeaturesQuery);
    }
    catch (error) {
        logger.error(error);
    }
    const user = await queryClient.ensureQueryData(userQuery_1.userQuery);
    let teamId = [''];
    try {
        teamId = await queryClient.ensureQueryData(teamIdQuery);
    }
    catch (error) {
        teamId = [''];
        logger.error(error);
    }
    const userRole = (0, userSelectors_1.isCompanyOrSupportAdmin)(user.roles)
        ? appConstants_1.overviewConstants.COMPANY_ADMIN
        : user.roles.find(role => role.securityGroupId === String(teamId))?.roleId || '';
    const approvalsQuery = (0, approvalQuery_1.getCombinedApprovalsData)(user, teamId?.[0] || '', true);
    const approvalsData = await queryClient.ensureQueryData({
        queryKey: approvalsQuery.queryKey,
        queryFn: approvalsQuery.queryFn,
    });
    let outOfOfficeSettings;
    try {
        // we show the approvals on for HSBC for company admin, but he might have no team created
        const currentTeamId = teamId?.[0] || '';
        if (currentTeamId) {
            const oooSettingsQuery = (0, teamQuery_1.getOooSettingsQuery)({
                userId: user.userId,
                teamId: teamId?.[0] || '',
            });
            outOfOfficeSettings = await queryClient.ensureQueryData({
                queryKey: oooSettingsQuery.queryKey,
                queryFn: oooSettingsQuery.queryFn,
            });
        }
        else {
            outOfOfficeSettings = {};
        }
    }
    catch (error) {
        logger.error(error);
        outOfOfficeSettings = {};
    }
    const teamData = await queryClient.ensureQueryData((0, teamQuery_1.teamsQuery)({ state: 'active' }));
    let allMembersFromAllTeams = [];
    if (userRole === appConstants_1.overviewConstants.COMPANY_ADMIN) {
        teams = (0, walletHelper_1.buildTeamsOptions)({ teams: teamData });
        try {
            const allMembersCollections = await Promise.all(teamData.map(async (team) => {
                const teamMembers = await queryClient.ensureQueryData((0, teamQuery_1.getTeamUsersQuery)({ teamId: team.id, query: '' }));
                return teamMembers?.users || [];
            }));
            allMembersFromAllTeams = allMembersCollections.flat();
            const uniqueUserIds = new Set();
            allMembersFromAllTeams = allMembersFromAllTeams.filter(member => {
                const isAlreadySeen = uniqueUserIds.has(member.userId);
                if (!isAlreadySeen) {
                    uniqueUserIds.add(member.userId);
                    return true;
                }
                return false;
            });
        }
        catch {
            allMembersFromAllTeams = [];
        }
    }
    return {
        user,
        userRole,
        teamId,
        approvalsData,
        outOfOfficeSettings,
        companyFeatures,
        teams,
        allMembersFromAllTeams,
    };
};
exports.activityLoader = activityLoader;
